// extracted by mini-css-extract-plugin
export var active = "_2l-7";
export var backButton = "_2l-6";
export var clone = "_2l-c";
export var collapseBar = "_2l-g";
export var collapseMode = "_2l-i";
export var dragHandle = "_2l-a";
export var dropdownIcon = "_2l-e";
export var hidden = "_2l-o";
export var iconContainer = "_2l-l";
export var iconSwapper = "_2l-n";
export var navItem = "_2l-4";
export var navItemIcon = "_2l-d";
export var navProfile = "_2l-5";
export var notificationDot = "_2l-m";
export var optionsContainer = "_2l-f";
export var primaryNav = "_2l-0";
export var primaryTab = "_2l-j";
export var secondaryNav = "_2l-1";
export var selected = "_2l-k";
export var settingsNav = "_2l-2";
export var settingsNavItems = "_2l-3";
export var show = "_2l-b";
export var sideNav = "_2l-h";
export var teamItem = "_2l-8";
export var userProfileItem = "_2l-9";